/**
 * Validation output for one variant, straight from
 * `validatePlatformContent` — the same function the connectors run before they
 * publish, so what the composer says here is what the API will say later.
 */

import { AlertTriangle, XCircle } from 'lucide-react';
import type { ValidationIssue } from '../../../shared/types';
import { cn } from '../../lib/utils';

export interface ValidationNotesProps {
  issues: ValidationIssue[];
  className?: string;
}

export function ValidationNotes({ issues, className }: ValidationNotesProps) {
  if (!issues.length) return null;

  return (
    <ul className={cn('space-y-1.5', className)}>
      {issues.map((issue) => (
        <li
          key={`${issue.code}-${issue.field ?? 'general'}-${issue.message}`}
          className={cn(
            'flex items-start gap-2 rounded-md border px-2.5 py-1.5 text-xs leading-relaxed',
            issue.level === 'error'
              ? 'border-danger/30 bg-danger-soft text-danger'
              : 'border-warning/30 bg-warning-soft text-warning',
          )}
        >
          <span className="mt-px shrink-0" aria-hidden>
            {issue.level === 'error' ? (
              <XCircle className="size-3.5" />
            ) : (
              <AlertTriangle className="size-3.5" />
            )}
          </span>
          <span>{issue.message}</span>
        </li>
      ))}
    </ul>
  );
}
